import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Alert from '../../../../../components/Alert';
import RateInput from '../RateInput/index';

const EditForm = ({ toggle, formRef, values, inputLabel, setRatesState, setIsFetchingList, setValues, currency }) => {
  const refInput = useRef(null);

  const [inputValue, setInputValue] = useState('50.00');
  const [errorText, setErrorText] = useState('');
  const [type, setType] = useState('0');

  useEffect(() => {
    refInput.current.focus();

    return () => {
      setErrorText('');
    };
  }, [setErrorText]);

  const onChangeType = (type, value) => {
    setType(type);
    setInputValue(value);
    refInput?.current?.focus();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    toggle();
    setIsFetchingList(true);
    setRatesState((prevState) => prevState.map((item) => {
      if (values.includes(item.id)) {
        return {
          ...item,
          price: inputValue,
          percent: type,
        };
      }
      return item;
    }));
    setValues([]);
    setTimeout(() => {
      setIsFetchingList(false);
    }, 1000);
  };

  return (
    <form ref={formRef} onSubmit={(e) => (!errorText ? handleSubmit(e) : e.preventDefault())} id="form-orders">
      {errorText && <Alert text={errorText} />}
      <RateInput
        refInput={refInput}
        inputLabel={inputLabel}
        valueType={type}
        value={inputValue}
        onChangeType={(type, value) => onChangeType(type, value)}
        onChangeValue={(value) => setInputValue(value)}
        currency={currency}
      />
    </form>
  );
};

EditForm.propTypes = {
  inputLabel: PropTypes.string,
  toggle: PropTypes.func,
  formRef: PropTypes.object,
  values: PropTypes.array,
  setRatesState: PropTypes.func,
  setIsFetchingList: PropTypes.func,
  setValues: PropTypes.func,
  currency: PropTypes.object,
};

export default EditForm;
